import { type CampaignDonor, getFullName } from "@packages/sdk";
import type { SortingState } from "@tanstack/react-table";

export const getBasePADUrl = ({ communityId }: { communityId: number }) =>
  `/admin/${communityId}`;

export const formatCurrency = (amountInCents: number): string => {
  return Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    useGrouping: true,
    maximumFractionDigits: 2,
    minimumFractionDigits: 2,
  }).format(amountInCents / 100);
};

export const formatDate = (date: string | Date): string => {
  return new Date(date).toLocaleDateString();
};

export const formatDonorName = (donor: CampaignDonor): string => {
  return getFullName({
    firstName: donor.name,
    lastName: donor.last_name,
  });
};

export const sortDonors = (
  donors: CampaignDonor[],
  sorting: SortingState,
): CampaignDonor[] => {
  if (sorting.length === 0) return donors;

  const sortConfig = sorting[0];
  return [...donors].sort((a, b) => {
    let aValue: number | string;
    let bValue: number | string;

    if (sortConfig.id === "name") {
      aValue = formatDonorName(a).toLowerCase();
      bValue = formatDonorName(b).toLowerCase();
    } else if (sortConfig.id === "amount_in_cents") {
      aValue = a.amount_in_cents;
      bValue = b.amount_in_cents;
    } else if (sortConfig.id === "created_at") {
      aValue = new Date(a.created_at).getTime();
      bValue = new Date(b.created_at).getTime();
    } else {
      return 0;
    }

    if (aValue < bValue) return sortConfig.desc ? 1 : -1;
    if (aValue > bValue) return sortConfig.desc ? -1 : 1;
    return 0;
  });
};
